import { BackendModel, BackendService } from "../core/backend.service";
import { CategoriaDto } from "../productos/categoria-producto/categoriaDto.model";

export class ImagenBannerDto extends BackendModel{
    id: number;
    file:File;
    nombre: string;
    path: string;
    fecha_subida: Date;
    es_desktop: string;
    categoriaProducto:CategoriaDto;
    paisId: number;

    constructor(protected backendService: BackendService, model?: ImagenBannerDto){
        super(backendService, model);
        this.categoriaProducto = new CategoriaDto();
    }
}


// WEBPACK FOOTER //
// ./src/app/banner/imagen-bannerDto.model.ts